import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format.js';
import { IconArrowRight } from '$partials/icon/index.js';
import { Media } from '$partials/media/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').TextMediaDual}
 */
const TextMediaDual = ({
    heading,
    headingLeft,
    headingRight,
    link,
    linkLeft,
    linkRight,
    mediaLeft,
    mediaRight,
    modulePaddingClasses = '',
    subHeading = '',
    text,
    textLeft,
    textRight
}) => {
    const href = formatLinkBlockToUrl(link);
    const hrefLeft = formatLinkBlockToUrl(linkLeft);
    const hrefRight = formatLinkBlockToUrl(linkRight);

    return (
        <section className='module-text-media-dual'>
            <div className={`layout-container bg-neutral-00 ${modulePaddingClasses}`}>
                <div className='layout-grid pb-16 sm:pb-32'>
                    <div className='w-full sm:w-6/12 layout-grid-col'>
                        {heading && (
                            <h2 className='type-style-heading'>
                                {href ? (
                                    <a
                                        className='underline'
                                        href={href}>
                                        <span>{heading}</span>
                                    </a>
                                ) : (
                                    heading
                                )}
                            </h2>
                        )}

                        {subHeading && (
                            <div
                                className='rich-text type-style-heading sm:w-10/12'
                                dangerouslySetInnerHTML={{ __html: subHeading }} />
                        )}

                        {text && (
                            <div
                                className='rich-text type-style-body sm:w-10/12 mt-10'
                                dangerouslySetInnerHTML={{ __html: text }} />
                        )}
                    </div>
                </div>

                <div className='layout-grid gap-y-16 sm:gap-y-0'>
                    {mediaLeft && (
                        <div className={`w-full sm:w-6/12 layout-grid-col text-[0] leading-[0] tracking-normal ${hrefLeft ? 'expand-interaction' : ''}`}>
                            <figure className={mediaLeft.videoEmbed ? '' : 'pointer-events-none select-none'}>
                                <Media
                                    image={mediaLeft.image ? { ...mediaLeft.image } : undefined}
                                    video={mediaLeft.video ? {
                                        autoPlay: true,
                                        controls: false,
                                        loop: true,
                                        muted: true,
                                        ...mediaLeft.video
                                    } : undefined}
                                    videoEmbed={mediaLeft.videoEmbed ? { ...mediaLeft.videoEmbed } : undefined} />
                            </figure>

                            {(headingLeft || textLeft) && (
                                <div className='sm:w-5/6 mt-8 sm:mt-24'>
                                    {headingLeft && (
                                        <h3 className='type-style-body-bold'>
                                            {hrefLeft ? (
                                                <a
                                                    className='flex items-center type-style-body-bold expand-interaction__action'
                                                    href={hrefLeft}>
                                                    <span>{headingLeft}</span>

                                                    <IconArrowRight
                                                        height={20}
                                                        width={20} />
                                                </a>
                                            ) : (
                                                headingLeft
                                            )}
                                        </h3>
                                    )}

                                    {textLeft && (
                                        <div
                                            className='richtext type-style-body'
                                            dangerouslySetInnerHTML={{ __html: textLeft }} />
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {mediaRight && (
                        <div className={`w-full sm:w-6/12 layout-grid-col text-[0] leading-[0] tracking-normal ${hrefRight ? 'expand-interaction' : ''}`}>
                            <figure className={mediaRight.videoEmbed ? '' : 'pointer-events-none select-none'}>
                                <Media
                                    image={mediaRight.image ? { ...mediaRight.image } : undefined}
                                    video={mediaRight.video ? {
                                        autoPlay: true,
                                        controls: false,
                                        loop: true,
                                        muted: true,
                                        ...mediaRight.video
                                    } : undefined}
                                    videoEmbed={mediaRight.videoEmbed ? { ...mediaRight.videoEmbed } : undefined} />
                            </figure>

                            {(headingRight || textRight) && (
                                <div className='sm:w-5/6 mt-8 sm:mt-24'>
                                    {headingRight && (
                                        <h3 className='type-style-body-bold'>
                                            {hrefRight ? (
                                                <a
                                                    className='flex items-center type-style-body-bold expand-interaction__action'
                                                    href={hrefRight}>
                                                    <span>{headingRight}</span>

                                                    <IconArrowRight
                                                        height={20}
                                                        width={20} />
                                                </a>
                                            ) : (
                                                headingRight
                                            )}
                                        </h3>
                                    )}

                                    {textRight && (
                                        <div
                                            className='richtext type-style-body'
                                            dangerouslySetInnerHTML={{ __html: textRight }} />
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TextMediaDual;
